import script from "./4B15M.vue?vue&type=script&setup=true&lang=js"
export * from "./4B15M.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__